import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Box, Typography } from '@curves/ui-base';

import MemberAvatar from './MemberAvatar';
import InfoCard from './InfoCard';
export const MemberInfoCard = ({
    className,
    avatar,
    avatarWidth = 5.5,
    name,
    nickname,
    memberNo,
    phone,
    link,
    membershipStatus,
    onClick,
    isShowAvatar = true,
    ...rest
}) => {
    return (
        <InfoCard className={clsx('member-info-card', className)} link={link} onClick={onClick} {...rest}>
            {isShowAvatar && (
                <MemberAvatar className={'member-info-card__avatar'} src={avatar} width={avatarWidth} membershipStatus={membershipStatus} alt={name} />
            )}
            <Box className={'member-info-card__content'}>
                <Typography className={'member-info-card__name'} title={name}>
                    {name}
                </Typography>
                {nickname && (
                    <Typography className={'member-info-card__nickname'} title={nickname}>
                        {nickname}
                    </Typography>
                )}
                {memberNo && (
                    <Typography className={'member-info-card__member-number'} title={memberNo}>
                        {memberNo}
                    </Typography>
                )}
                {phone && (
                    <Typography className={'member-info-card__phone'} title={phone}>
                        {phone}
                    </Typography>
                )}
            </Box>
        </InfoCard>
    );
};
MemberInfoCard.prototype = {
    className: PropTypes.string,
    avatar: PropTypes.string,
    avatarWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
    nickname: PropTypes.string,
    memberNo: PropTypes.string,
    phone: PropTypes.string,
    link: PropTypes.string,
    membershipStatus: PropTypes.number,
    onClick: PropTypes.func,
    isShowAvatar: PropTypes.bool,
};
export default MemberInfoCard;
